<template>
  <div class="side-smaller-ads ad-slot">
    <div class="ad_container">
      <div class="ad_wrapper">
        <div v-if="screen.isDesktop" id="div-gpt-ad-1556609068299-0"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'side-smaller-ads',
  computed: {
    screen() {
      return this.$store.state.screen;
    },
  },
  mounted() {
    if (document.readyState == 'complete') {
      this.loadAds();
    } else {
      document.addEventListener(
        'scriptReady',
        (e) => {
          this.loadAds();
        },
        true
      );
    }
  },
  methods: {
    loadAds() {
      const el = this;
      googletag.cmd.push(() => {
        googletag.pubads().enableSingleRequest();
        googletag.pubads().collapseEmptyDivs();
        googletag.pubads().addEventListener('slotRenderEnded', function (event) {
          if (event.isEmpty) {
            const id = event.slot.getSlotElementId();
            if (id) {
              if (el.$refs['top-ads'] && el.$refs['top-ads'].classList.contains('ad-slot')) {
                el.$refs['top-ads'].style.display = 'none';
              }
            }
          }
        });

        if (this.screen.isDesktop) {
          googletag
            .defineSlot('/187290464/Revamp_Desktop_SideBanner2', [250, 250], 'div-gpt-ad-1556609068299-0')
            .addService(googletag.pubads())
            .setCollapseEmptyDiv(true);
          googletag.enableServices();
          googletag.display('div-gpt-ad-1556609068299-0');
        }
      });
    },
  },
};
</script>

<style lang="scss">
.ad_container {
  text-align: center;
}

.ad_wrapper {
  display: inline-block;
  position: relative;
}

.side-smaller-ads {
  padding-bottom: 24px;
}
</style>
